export default {
    resources: [
        {
            id: 1,
            title: 'The North Face Presents: Defiance',
            slug: 'the-north-face-presents-defiance',
            description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
            author: 'The North Face',
            date: '1995-12-17T03:24:00',
            type: 'video',
            content: 'https://player.vimeo.com/video/370200524',
            images: [
                // eslint-disable-next-line max-len
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBuDhZ0HKselDBoNK_GMl96S1JlsBu4qdo579nSX_r44IFZXMb&s',
            ],
            tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
            related: [
                {
                    id: 2,
                    title: 'Refinance calculator - Should you refinance your mortgage?',
                    slug: 'refinance-calculator-should-you-refinance-your-mortgage',
                    description: 'Try this refinance caculator to understand how much' +
                        ' you could save if you refinance your mortgage',
                    author: 'The North Face',
                    date: 'Feb 12, 2019',
                    type: 'calculator',
                    images: [
                        'https://s3.envato.com/files/245551182/T13A8556.jpg',
                    ],
                    tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                },
                {
                    id: 3,
                    title: `How to make homebuying easier when you're self-employed`,
                    slug: 'how-to-make-homebuying-easier-when-you-are-self-employed',
                    description: `Being a self-employed borrower can make homebuying more difficult.`,
                    author: 'The North Face',
                    date: '1995-12-17T03:24:00',
                    type: 'article',
                    images: [
                        'https://previews.123rf.com/images/drverner/drverner1602/' +
                        'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                    ],
                    tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                },
            ],
        },
        {
            id: 2,
            title: 'Refinance calculator - Should you refinance your mortgage?',
            slug: 'refinance-calculator-should-you-refinance-your-mortgage',
            description: 'Try this refinance caculator to understand' +
                ' how much you could save if you refinance your mortgage',
            author: 'The North Face',
            date: '1995-12-17T03:24:00',
            type: 'tutorial',
            steps: [
                {
                    title: 'Tutorial Step 1',
                    description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
                    content: 'https://player.vimeo.com/video/375749787',
                },
                {
                    title: 'Tutorial Step 2',
                    description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
                    content: 'https://player.vimeo.com/video/375749787',
                },
                {
                    title: 'Tutorial Step 3',
                    description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
                    content: 'https://player.vimeo.com/video/375749787?color=fff&title=0&byline=0&portrait=0',
                },
            ],
            images: [
                'https://s3.envato.com/files/245551182/T13A8556.jpg',
            ],
            tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
            related: [
                {
                    id: 2,
                    title: 'Refinance calculator - Should you refinance your mortgage?',
                    slug: 'refinance-calculator-should-you-refinance-your-mortgage',
                    description: 'Try this refinance caculator to understand' +
                        ' how much you could save if you refinance your mortgage',
                    author: 'The North Face',
                    date: '1995-12-17T03:24:00',
                    type: 'calculator',
                    images: [
                        'https://s3.envato.com/files/245551182/T13A8556.jpg',
                    ],
                    tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                },
                {
                    id: 3,
                    title: `How to make homebuying easier when you're self-employed`,
                    slug: 'how-to-make-homebuying-easier-when-you-are-self-employed',
                    description: `Being a self-employed borrower can make homebuying more difficult.`,
                    author: 'The North Face',
                    date: '1995-12-17T03:24:00',
                    type: 'article',
                    images: [
                        'https://previews.123rf.com/images/drverner/drverner1602/' +
                        'drverner160200043/54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                    ],
                    tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                },
            ],
        },
        {
            id: 3,
            title: `How to make homebuying easier when you're self-employed`,
            slug: 'how-to-make-homebuying-easier-when-you-are-self-employed',
            description: `But I must explain to you how all this mistaken idea of denouncing pleasure
       and praising pain was born and I will give you a complete account of the system.`,
            disclaimer: 'But I must explain to you how all this mistaken idea of denouncing pleasure' +
                ' and praising pain was born and I will give you a complete account of the system, and expound' +
                ' the actual teachings of the great explorer of the truth, the master-builder of human happiness.',
            author: 'The North Face',
            date: '1995-12-17T03:24:00',
            type: 'article',
            estimation: 7,
            content: 'But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain ' +
                'was born and I will give you a complete account of the system, and expound the actual teachings of ' +
                'the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes,' +
                ' or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue ' +
                'pleasure rationally encounter consequences that are extremely painful.' +
                ' Nor again is there anyone who ' +
                'loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally ' +
                'circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial ' +
                'example, which of us ever undertakes laborious physical exercise, except to obtain some advantage ' +
                'from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has ' +
                'no annoying consequences, or one who avoids a pain that produces no resultant pleasure? But I must' +
                ' explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and ' +
                'I will give you a complete account of the system, and expound the actual teachings of the great ' +
                'explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids' +
                ' pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure ' +
                'rationally encounter consequences that are extremely painful. Nor again is there anyone who loves ' +
                'or pursues or desires to obtain pain of itself, because it is pain, but because occasionally ' +
                'circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial' +
                ' example, which of us ever undertakes laborious physical exercise, except to obtain some advantage ' +
                'from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no' +
                ' annoying consequences, or one who avoids a pain that produces no resultant pleasure?',
            images: [
                'https://previews.123rf.com/images/drverner/drverner1602/drverner160200043/' +
                '54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
            ],
            tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
            sources: [
                {
                    name: 'Source Name',
                    href: 'http://www.whatever.com',
                },
                {
                    name: 'Source Name',
                    href: 'http://www.whatever.com',
                },
                {
                    name: 'Source Name',
                    href: 'http://www.whatever.com',
                },
            ],
            related: [
                {
                    id: 2,
                    title: 'Refinance calculator - Should you refinance your mortgage?',
                    slug: 'refinance-calculator-should-you-refinance-your-mortgage',
                    description: 'Try this refinance caculator to understand' +
                        ' how much you could save if you refinance your mortgage',
                    author: 'The North Face',
                    date: '1995-12-17T03:24:00',
                    type: 'calculator',
                    images: [
                        'https://s3.envato.com/files/245551182/T13A8556.jpg',
                    ],
                    tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                },
                {
                    id: 3,
                    title: `How to make homebuying easier when you're self-employed`,
                    slug: 'how-to-make-homebuying-easier-when-you-are-self-employed',
                    description: `Being a self-employed borrower can make homebuying more difficult.`,
                    author: 'The North Face',
                    date: '1995-12-17T03:24:00',
                    type: 'article',
                    images: [
                        'https://previews.123rf.com/images/drverner/drverner1602/drverner160200043/' +
                        '54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                    ],
                    tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                },
            ],
        },
        {
            id: 4,
            title: `Loan Estimate 101`,
            slug: 'loan-estimate-101',
            description: `If you're home shopping or refinancing, you're likely looked at rate 
      tables or gotten quotes from lenders. Did you know there's an accurate way of bla bla`,
            author: 'The North Face',
            date: '1995-12-17T03:24:00',
            type: 'tutorial',
            images: [
                'https://www.thespruce.com/thmb/fj3GluPEYW2u_WkgIvBxARyODXA=/1920x1281/filters:no_upscale():' +
                'max_bytes(150000):strip_icc()/10-fin-nook-in-hallway-becomes-office-5a1c4f109e9427003722bc9d.jpg',
            ],
            tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
            steps: [
                {
                    title: 'Tutorial Step 1',
                    description: 'Sed ut perspiciatis unde omnis iste natus error sit' +
                        ' voluptatem accusantium doloremque' +
                        ' laudantium, totam rem aperiam, eaque ipsa quae ab illo' +
                        ' inventore veritatis et quasi architecto' +
                        ' beatae vitae dicta sunt explicabo. Nemo enim ipsam' +
                        ' voluptatem quia voluptas sit aspernatur aut' +
                        ' odit aut fugit, sed quia consequuntur magni dolores eos' +
                        ' qui ratione voluptatem sequi nesciunt.' +
                        ' Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,' +
                        ' consectetur, adipisci velit,' +
                        ' sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat' +
                        ' voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit ' +
                        'laboriosam, nisi ut aliquid ex ea commodi consequatur.',
                    content: 'https://player.vimeo.com/video/375749787',
                },
                {
                    title: 'Tutorial Step 2',
                    description: 'Sed ut perspiciatis unde omnis iste natus error sit' +
                        ' voluptatem accusantium doloremque' +
                        ' laudantium, totam rem aperiam, eaque ipsa quae ab illo' +
                        ' inventore veritatis et quasi architecto' +
                        ' beatae vitae dicta sunt explicabo. Nemo enim ipsam' +
                        ' voluptatem quia voluptas sit aspernatur aut' +
                        ' odit aut fugit, sed quia consequuntur magni dolores eos' +
                        ' qui ratione voluptatem sequi nesciunt.' +
                        ' Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,' +
                        ' consectetur, adipisci velit,' +
                        ' sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat' +
                        ' voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit ' +
                        'laboriosam, nisi ut aliquid ex ea commodi consequatur.',
                    content: 'https://player.vimeo.com/video/375749787',
                },
                {
                    title: 'Tutorial Step 3',
                    description: 'Sed ut perspiciatis unde omnis iste natus error sit' +
                        ' voluptatem accusantium doloremque' +
                        ' laudantium, totam rem aperiam, eaque ipsa quae ab illo' +
                        ' inventore veritatis et quasi architecto' +
                        ' beatae vitae dicta sunt explicabo. Nemo enim ipsam' +
                        ' voluptatem quia voluptas sit aspernatur aut' +
                        ' odit aut fugit, sed quia consequuntur magni dolores eos' +
                        ' qui ratione voluptatem sequi nesciunt.' +
                        ' Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,' +
                        ' consectetur, adipisci velit,' +
                        ' sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat' +
                        ' voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit ' +
                        'laboriosam, nisi ut aliquid ex ea commodi consequatur.',
                    content: 'https://player.vimeo.com/video/375749787?color=fff&title=0&byline=0&portrait=0',
                },
            ],
            related: [
                {
                    id: 2,
                    title: 'Refinance calculator - Should you refinance your mortgage?',
                    slug: 'refinance-calculator-should-you-refinance-your-mortgage',
                    description: 'Try this refinance caculator to understand how much you could save ' +
                        'if you refinance your mortgage',
                    author: 'The North Face',
                    date: '1995-12-17T03:24:00',
                    type: 'calculator',
                    images: [
                        'https://s3.envato.com/files/245551182/T13A8556.jpg',
                    ],
                    tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                },
                {
                    id: 3,
                    title: `How to make homebuying easier when you're self-employed`,
                    slug: 'how-to-make-homebuying-easier-when-you-are-self-employed',
                    description: `Being a self-employed borrower can make homebuying more difficult.`,
                    author: 'The North Face',
                    date: '1995-12-17T03:24:00',
                    type: 'article',
                    images: [
                        'https://previews.123rf.com/images/drverner/drverner1602/drverner160200043/' +
                        '54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                    ],
                    tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                },
            ],
        },
        {
            id: 5,
            title: `Title goes here and is pretty short`,
            slug: 'title-goes-here-and-is-pretty-short',
            description: `Tum dicere exorsus est et inter argumentum conclusionemque rationis et impetus quo quaeriums`,
            author: 'The North Face',
            date: '1995-12-17T03:24:00',
            type: 'video',
            images: [
                'https://images.thestar.com/W2JakJ7dlpoWvnltIu_HbZ3RTaM=/1200x795/smart/' +
                'filters:cb(2700061000)/https://www.thestar.com/content/dam/thestar/life/travel/2015/12/20/' +
                'ocean-view-and-oceanfront--theres-a-difference-when-it-comes-to-booking-a-hotel-room/ocean-view.jpg',
            ],
            tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
            related: [],
        },
        {
            id: 6,
            title: `How to make homebuying easier when you're self-employed`,
            slug: 'how-to-make-homebuying-easier-when-you-are-self-employed-1',
            description: `Being a self-employed borrower can make homebuying more difficult.`,
            author: 'The North Face',
            date: '1995-12-17T03:24:00',
            type: 'article',
            images: [
                'https://previews.123rf.com/images/drverner/drverner1602/drverner160200043/' +
                '54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
            ],
            tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
            related: [],
        },
        {
            id: 7,
            title: `Loan Estimate 101`,
            slug: 'loan-estinate-101-1',
            description: `If you're home shopping or refinancing, you're likely looked at rate tables or gotten
       quotes from lenders. Did you know there's an accurate way of bla bla`,
            author: 'The North Face',
            date: '1995-12-17T03:24:00',
            type: 'tutorial',
            images: [
                'https://www.thespruce.com/thmb/fj3GluPEYW2u_WkgIvBxARyODXA=/1920x1281/filters:no_upscale():' +
                'max_bytes(150000):strip_icc()/10-fin-nook-in-hallway-becomes-office-5a1c4f109e9427003722bc9d.jpg',
            ],
            tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
            related: [],
        },
        {
            id: 8,
            title: `Title goes here and is pretty short`,
            slug: 'title-goes-here-ans-is-pretty-short-1',
            description: `Tum dicere exorsus est et inter argumentum conclusionemque rationis et impetus quo quaeriums`,
            author: 'The North Face',
            date: '1995-12-17T03:24:00',
            type: 'video',
            images: [
                'https://images.thestar.com/W2JakJ7dlpoWvnltIu_HbZ3RTaM=/1200x795/smart/filters:cb(2700061000)/' +
                'https://www.thestar.com/content/dam/thestar/life/travel/2015/12/20/' +
                'ocean-view-and-oceanfront--theres-a-difference-when-it-comes-to-booking-a-hotel-room/ocean-view.jpg',
            ],
            tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
            related: [
                {
                    id: 2,
                    title: 'Refinance calculator - Should you refinance your mortgage?',
                    slug: 'refinance-calculator-should-you-refinance-your-mortgage',
                    description: 'Try this refinance caculator to understand how much ' +
                        'you could save if you refinance your mortgage',
                    author: 'The North Face',
                    date: '1995-12-17T03:24:00',
                    type: 'calculator',
                    images: [
                        'https://s3.envato.com/files/245551182/T13A8556.jpg',
                    ],
                    tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                },
                {
                    id: 3,
                    title: `How to make homebuying easier when you're self-employed`,
                    slug: 'how-to-make-homebuying-easier-when-you-are-self-employed',
                    description: `Being a self-employed borrower can make homebuying more difficult.`,
                    author: 'The North Face',
                    date: '1995-12-17T03:24:00',
                    type: 'article',
                    images: [
                        'https://previews.123rf.com/images/drverner/drverner1602/drverner160200043/' +
                        '54173438-windows-in-a-row-on-facade-of-apartment-building.jpg',
                    ],
                    tags: ['Life', 'North', 'Nature', 'Snow', 'Winter', 'Defiance'],
                },
            ],
        },
    ],
};
